import { Accordion, AccordionDetails, AccordionSummary, Box, Fab, FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KitPackageElementSection from "./KitPackageElementSection";
import { PackagingType } from "../../api/KitApi";
import { PackageElement } from "./KitPackageElement";
import { useState } from "react";
import TextInputField from "../ui/TextInputField";


interface Props {
  kitPackageName: string;
  availableForms: PackageElement[];
  availableShapes: PackageElement[];
  selectedForms: PackageElement[];
  selectedShapes: PackageElement[];
  packagingType: PackagingType;
  onKitPackageDeleted: () => void;
  onKitPackageNameChanged: (kitPackageName: string) => void;
  onFormPackageElementQuantityChanged: (packageElement: PackageElement, quantity: number) => void;
  onShapePackageElementQuantityChanged: (packageElement: PackageElement, quantity: number) => void;
  onPackagingTypeSelected: (packagingType: PackagingType) => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    marginTop: theme.spacing(-2)
  },
  forms: {
    paddingRight: theme.spacing(2)
  },
  sections: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(3)
  },
  shapes: {
    paddingLeft: theme.spacing(2)
  },
  packagingType: {
    marginLeft: theme.spacing(1),
    minWidth: 200
  },
  inputField: {
    width: 400
  }
}));

const KitPackageDefinition = (props: Props) => {
  const classes = useStyles();
  const [kitPackageName, setKitPackageName] = useState<string>(props.kitPackageName);
  const [isKitPackageNameEdited, setKitPackageNameEdited] = useState<boolean>(false);
  const packagingTypeLabelId = `packagingtype-label-${kitPackageName}`;

  const handleDeleteKitPackageClicked = () => props.onKitPackageDeleted();

  const handlePackagingTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const packagingType = event.target.value as PackagingType;
    props.onPackagingTypeSelected(packagingType);
  };

  const handleEditKitPackageClicked = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (isKitPackageNameEdited) {
      props.onKitPackageNameChanged(kitPackageName);
    }
    setKitPackageNameEdited(!isKitPackageNameEdited);
  };

  const onPackageNameChanged = (packageName: string) => {
    setKitPackageName(packageName);
  };

  return <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Fab
        className={ classes.button }
        aria-label='delete'
        color='secondary'
        onClick={() => handleDeleteKitPackageClicked()}
        size='small'
      >
        <DeleteIcon />
      </Fab>
      <Fab
        className={ classes.button }
        aria-label='edit'
        color='primary'
        onClick={handleEditKitPackageClicked}
        size='small'
      >
        { isKitPackageNameEdited ? <CheckIcon/> : <EditIcon /> }
      </Fab>
      <TextInputField
        classes={classes}
        initialValue={ props.kitPackageName }
        calculatedValue={ kitPackageName }
        onValueChange={ onPackageNameChanged }
        disabled={ !isKitPackageNameEdited }
      />
    </AccordionSummary>
    <AccordionDetails>
      <Box>
        <FormControl>
          <InputLabel id={ packagingTypeLabelId } className={ classes.packagingType }>Sposób pakowania</InputLabel>
          <Select className={ classes.packagingType }
            labelId={ packagingTypeLabelId }
            value={ props.packagingType || null }
            onChange={ handlePackagingTypeChange }>
              <MenuItem value='foil'>folia</MenuItem>
              <MenuItem value='string'>wiązanie sznurkiem</MenuItem>
              <MenuItem value='pallet'>paleta</MenuItem>
              <MenuItem value='stretch'>folia stretch</MenuItem>
              <MenuItem value='none'>brak</MenuItem>
          </Select>
        </FormControl>
        <Box className={classes.sections}>
          { props.availableForms.length > 0 &&
          <Box className={classes.forms}>
            <div>Formatki</div>
            <KitPackageElementSection
              availablePackageElements={ props.availableForms }
              selectedPackageElements={ props.selectedForms }
              onPackageElementQuantityChanged={ props.onFormPackageElementQuantityChanged }
              />
          </Box> }
          <Box className={classes.shapes}>
            <div>Wykroje</div>
            <KitPackageElementSection
              availablePackageElements={ props.availableShapes }
              selectedPackageElements={ props.selectedShapes }
              onPackageElementQuantityChanged={ props.onShapePackageElementQuantityChanged }
              />
          </Box>
        </Box>
      </Box>
    </AccordionDetails>
  </Accordion>
};

export default KitPackageDefinition;